export class SpatialAdjustCourse {

    constructor(json: any = null) {
        if (json) {
            Object.assign(this, json);
        }
    }

    siteId: number;
    turfRadOrgId: number;
    name: string;
    lynxInstallationId: string;
    lynxCloudCourseId: number;
    lynxDriveCourseId: number;
    turfRadCourseId: number;
}
